import "./App.css";
import useReveal from "./hooks/useReveal";
import AnnouncementBar from "./components/AnnouncementBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Ambiente from "./components/Ambiente";
import Menu from "./components/Menu";
import Testimonials from "./components/Testimonials";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";

function App() {
  useReveal();
  return (
    <div className="App bg-[#100d0b] min-h-screen">
      <AnnouncementBar />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Ambiente />
        <Menu />
        <Testimonials />
        <Reservation />
      </main>
      <Footer />
    </div>
  );
}

export default App;
